import { render, staticRenderFns } from "./uploadCopy.vue?vue&type=template&id=24ba07e2&scoped=true"
import script from "./uploadCopy.vue?vue&type=script&lang=js"
export * from "./uploadCopy.vue?vue&type=script&lang=js"
import style0 from "./uploadCopy.vue?vue&type=style&index=0&id=24ba07e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba07e2",
  null
  
)

export default component.exports